import React, { useEffect, useMemo, useState, useRef } from 'react';
import { AiOutlineDelete } from 'react-icons/ai';
import { BiSolidEdit } from 'react-icons/bi';
import { FiPlus, FiArrowLeft } from 'react-icons/fi';
import { IoIosArrowDown } from 'react-icons/io';
import { debounce, trim, ceil, capitalize, isEmpty, set, isArray, map } from 'lodash';
import { Spin, Popover, notification, Tooltip, Upload, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import XLSX from 'xlsx';
import { sortBy as sort, indexOf, flatMap, minBy, groupBy, find } from 'lodash';
import { GoUpload } from 'react-icons/go';
import { IoCloudUploadOutline } from 'react-icons/io5';

import Badge from '../../../components/uiComponent/bages';
import Button from '../../../components/uiComponent/button/index';
import SearchInput from '../../../components/uiComponent/inputs/searchinput';
import Pagination from '../../../components/pagination/index';
import AgGrid from '../../../components/ag-grid-table/index';
import Input from '../../../components/uiComponent/inputs/input/index';
import Modal from '../../../components/uiComponent/modal/index';
import PoRowDetails from './PoRowDetails';
import AddManualProduct from './add-Product/addProductManual';
import Alert from '../../../components/uiComponent/alert';
import ReceiveProductDrawer from '../po-warehouse-details/custom-drawer';
import { PoWarehouseDetailsWrapper } from '../po-warehouse-details/style.js';

import iconPurple from '../../../assets/images/box-icon-purple.svg';
import iconBlue from '../../../assets/images/box-icon-blue.svg';
import iconRed from '../../../assets/images/box-icon-red.svg';
import iconYellow from '../../../assets/images/box-icon-yellow.svg';
import iconGreen from '../../../assets/images/box-icon-green.svg';
import iconOrange from '../../../assets/images/box-icon-orange.svg';
import ProductImg from '../../../assets/images/newImages/nestle.svg';
import InfoIcon from '../../../assets/icons/info-black.svg';
import WarningIcon from '../../../assets/icons/warning-modal-icon.svg';
import uploadIcon from '../../../assets/images/newImages/upload-icon.svg';
import WarningInfoIcon from '../../../assets/images/newImages/info-icon.svg';
import FileIcon from '../../../assets/icons/file-icon.svg';
import SideDrawerIcon from '../../../assets/icons/side-bar-icon.svg';
import Receiving from '../../../assets/icons/Receiving.svg';
import MarkAsResolved from '../../../assets/icons/mark-as-resolved-icon.svg';

import { PoDetailsWrapper } from './style';
import { ModalWrapper } from '../po-history/style.js';
import InventoryWrapper from '../../inventory/style';
import useResponsiveTableHeight from '../../../hooks/useResponsiveTableHeight';
import AddProductByUpload from './add-product/addproductByUpload';
import { 
  GetPoDetails, 
  ConfirmPo, 
  GetPoItems, 
  EditPoItem, 
  setField, 
  DeletePoItem, 
  UpdatePoItemsFile, 
  DeleteBulkPoItem, 
  populateHighlightState, 
  GetWarehousePoHistory, 
  UpdatePo, 
  BulkReceive,
  ExportAsinData,
  ExportFilteredPoItems
} from '../../../slices/po';

import { GetPresignedUrl } from '../../../slices/aws-services';
import { CreateWorkOrder, GetUserWorkOrders } from '../../../slices/work-orders';
import { GetErroredItems, GetPoItemsForDraftWoModal } from '../../../slices/po';

import ErroredItemsModal from './ErroredItemsModal';
import AddToDraftWoModal from './AddToDraftWoModal';

const { Dragger } = Upload;

const getPoStatusBadgeClass = (status) => {
  if (!status) return '';
  const s = status.toLowerCase();
  if (s === 'pending') return 'badge-pending';
  if (s === 'confirmed') return 'badge-confirmed';
  if (s === 'arrived') return 'badge-arrived';
  if (s === 'receiving') return 'badge-receiving';
  if (s === 'processed') return 'badge-processed';
  if (s === 'deleted') return 'badge-deleted';
  return '';
};

let gridApi;
let gridColumnApi;

const PoDetails = () => {
  const dispatch = useDispatch();
  const { poId } = useParams();

  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '', itemsFilter: 'viewAll' });
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const [editPoItemData, setEditPoItemData] = useState({ id: '', key: '', value: '' });
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [addProduct, setAddProduct] = useState(false);
  const [editValue, setEditValue] = useState();
  const [uploadAddProduct, setUploadAddProduct] = useState(false);
  const [editPoItems, setEditPoItems] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [poItemId, setPoItemId] = useState(null);
  const [uploadMapping, setUploadMapping] = useState(false);
  const [addProductFile, setAddProductFile] = useState(false);
  const [poItemsSkuMapping, setPoItemsSkuMapping] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [uploadFile, setUploadFile] = useState({});
  const [fileUploadingLoading, setFileUploadingLoading] = useState(false);
  const [orderItems, setOrderItems] = useState([]);
  const [highlightRows, setHighlightRows] = useState(false);
  const [showWorkOrderOption, setShowWorkOrderOption] = useState(false);
  const [showErroredItemsModal, setShowErroredItemsModal] = useState(false);
  const [isCreateWorkOrder, setIsCreateWorkOrder] = useState(false);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [revertReceivingStatus, setRevertReceivingStatus] = useState(false);
  const [bulkReceivingModal, setBulkReceivingModal] = useState(false);
  const [markAsReceivedModal, setMarkAsReceivedModal] = useState(false);
  const [arrivedModalOpen, setArrivedModalOpen] = useState(false);
  const [selectedPoItems, setSelectedPoItems] = useState([]);
  const [showAddToDraftWoModal, setShowAddToDraftWoModal] = useState(false);
  const [addToDraftWoItems, setAddToDraftWoItems] = useState([]);
  const [preparingAddToDraftWo, setPreparingAddToDraftWo] = useState(false);

  const divRef = useRef(null);
  const { tableHeight, tableSectionRef, paginationRef } = useResponsiveTableHeight({
    minHeight: 240,
    bottomSpacing: 24,
    observeSelectors: ['.po-detail-header', '.box-row', '.po-items-toolbar']
  });
  const navigate = useNavigate();

  const {
    fetchingPoDetails,
    poDetails,
    confirmingPo,
    poItems,
    totalPoItemsCount,
    fetchingPoItems,
    updatingPoItem,
    deletingPoItem,
    exportingData,
    fetchingErroredItems,
    fetchingWarehousePoDetails,
    bulkReceivingLoading
  } = useSelector((state) => state.pos || {});
  
  const { currentUser } = useSelector((state) => state.auth || {}); 

  const {
    creatingWorkOrder
  } = useSelector((state) => state.workOrders || {});

  const {
    file_name, status, invoice_quantity = 0, ordered_quantity = 0, total_skus = 0,
    received_quantity = 0, po_value = 0, po_by_order_quantity = 0, total_products = 0, warehouses_v2, vendor
  } = poDetails || {};

  useEffect(() => {
    if (gridApi && poItems?.length > 0) {
      gridApi.forEachNode((node) => {
        if (selectedPoItems.some(i => i.id === node.data.id)) {
          node.setSelected(true, false, true);
        }
      });
      // Refresh selectedPoItems with the latest row data from poItems so post-selection
      // edits (e.g., unmap → remap SKU) propagate into the "Create with Selected" /
      // "Add Selected" handlers. Rows not present in the current page (cross-page
      // selections) are left untouched.
      setSelectedPoItems(prev => {
        if (!prev.length) return prev;
        const byId = new Map(poItems.map(it => [it.id, it]));
        return prev.map(sel => byId.get(sel.id) ?? sel);
      });
    }
  }, [poItems, gridApi]);

  useEffect(() => {
    dispatch(GetPoDetails(poId));
    dispatch(GetPoItems({
      id: poId,
      page,
      filters
    }));
  }, []);
  
  useEffect(()=>{
    setIsRowSelected(false);
  },[fetchingPoItems,confirmingPo,updatingPoItem,deletingPoItem,creatingWorkOrder, fetchingErroredItems]);

  const boxData = [
    {
      label: 'Total SKUs',
      value: Number(total_skus || 0)?.toLocaleString('en-US'),
      icon: iconPurple,
      className: 'box-purple',
      key: 'totalProducts'
    },
    {
      label: 'Total Order Qty',
      value: Number(ordered_quantity || 0)?.toLocaleString('en-US'),
      icon: iconBlue,
      className: 'box-blue',
      key: 'totalOrderedQty'
    },
    {
      label: 'Total Invoice Qty',
      value: Number(invoice_quantity || 0)?.toLocaleString('en-US'),
      icon: iconRed,
      className: 'box-red',
      key: 'totalInvoiceQty'
    },
    {
      label: 'Total Received Qty',
      value: Number(received_quantity || 0)?.toLocaleString('en-US'),
      icon: iconYellow,
      className: 'box-yellow',
      key: 'totalReceivedQty'
    },
    {
      label: 'PO Value By Invoice Qty',
      // value: `$${Number(po_value || 0).toFixed(2)}`,
      value: `$${Number(po_value || 0)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      icon: iconGreen,
      className: 'box-green',
      key: 'totalPoValue'
    },
    {
      label: 'PO Value By Order Qty',
      // value: `$${Number(po_by_order_quantity || 0).toFixed(2)}`,
      value: `$${Number(po_by_order_quantity || 0)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      icon: iconGreen,
      className: 'box-green',
      key: 'totalPoValue'
    },
    {
      label: 'Total Products',
      value: Number(total_products || 0)?.toLocaleString('en-US'),
      icon: iconGreen,
      className: 'box-green',
      key: 'totalProducts'
    }
  ];

  const handleSearchProduct = debounce((value) => {
    if (trim(value) || filters.search) {
      setFilters({ search: value });
      setPage(page => ({ ...page, pageNumber: 1 }));
      dispatch(GetPoItems({
        id: poId,
        page: { ...page, pageNumber: 1 },
        filters: { search: value },
        sortBy
      }));
    }
  }, 800);

  const handleFileUpload = async () => {
    let uploadedFile = {};
    if (!isEmpty(uploadFile)) {
      if (!uploadFile?.name?.toLowerCase().includes('po items')) {
        notification.error({
          message: 'File Error',
          description: 'Select at least one row to export and upload the updated file.'
        });
        setUploadFile({});
        setPopoverVisible(false);
        return;
      }
      setFileUploadingLoading(true);
      await dispatch(GetPresignedUrl({ files: [uploadFile] })).then(({ payload }) => {
        if (!payload?.error) {
          uploadedFile = payload[0];
        }
      });
      if (uploadedFile) {
        dispatch(UpdatePoItemsFile({ fileName: uploadedFile?.key, fileUrl: uploadedFile?.url, fileType: uploadedFile?.extension, poId, type: 'edit-invoice' })).then(({ payload }) => {
          if (!payload?.success) {
          }
          refreshGridClick();
          setUploadFile({});
          setPopoverVisible(false);
        });
        setFileUploadingLoading(false);
      }
    };
  };

  const handleSave = (id, key, value) => {
    if (!id || !key) return;

    if (['unit_cost', 'case_quantity', 'order_quantity', 'invoice_quantity'].includes(key)) {
      if (!value || isNaN(value) || Number(value) <= 0) {
        setEditPoItemData({ id: '', key: '', value: '' });
        return notification.error({
          top: 65,
          message: 'Edit Po Item',
          description: 'Invalid value'
        });
      }
    }

    const originalItem = poItems.find(item => item.id === id);
    if (originalItem && String(originalItem[key]) === String(value)) {
      setEditPoItemData({ id: '', key: '', value: '' });
      return;
    }

    dispatch(EditPoItem({
      id,
      key,
      value
    })).then(({ payload }) => {
      if (payload?.success) {
        dispatch(setField({
          field: 'poItems',
          id,
          key,
          value
        }));
        dispatch(GetPoDetails(poId));
        // The edited field itself is patched above for an instant UI update, but columns
        // derived from it server-side (extended_cost, missing_units, available_stock,
        // pending_on_po, etc.) stay stale unless the row data is refetched.
        dispatch(GetPoItems({
          id: poId,
          page,
          filters,
          sortBy
        }));
      }
      setEditPoItemData({ id: '', key: '', value: '' });
    });
  };

  const handleKeyDown = (e) => {
    e.stopPropagation();

    if (e.key === 'Enter') {
      const { value } = e.target || {};
      const { id, key } = editPoItemData || {};
      handleSave(id, key, value);
    }
  };

  const columnDefs = [
    {
      headerName: '',
      width: 75,
      field: 'seller_skus.length',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      cellRenderer: 'agGroupCellRenderer',
      suppressRowClickSelection: true
    },
    {
      headerName: 'Title',
      filter: true,
      minWidth: 164,
      flex: 1,
      sortable: true,
      field: 'title',
      cellRenderer: ({ data }) => {
        const { image_url, name } = data?.product || {};
        // picking name: vendor item name (for this PO's vendor) first, product name second
        const displayName = data?.vendor_item_name || name;

        return (
          <div className='card-wrapper'>
            <img src={image_url || ProductImg} alt="ProductImg" className='prod-image' title="ProductImg" />
            <Tooltip title={displayName}>
              <span className='two-line-ellipsis'>
                {displayName || '---'}
              </span>
            </Tooltip>
          </div>
        );
      }
    },
    {
      headerName: 'Identifier',
      filter: true,
      minWidth: 100,
      flex: 1,
      field:'identifier_value',
      sortable: true,
      comparator: () => 0,
      cellRenderer: ({ data }) => {
        const { identifier_type, identifier_value, product } = data || {};
        const { identifier_type: prod_identifier_type } = product || {};

        return (
          <div className='title-wrapper'>
            <span>{(identifier_type || prod_identifier_type)?.toUpperCase() || ''}</span>
            <span className='upc-code'>{identifier_value || ''}</span>
          </div>
        );
      }
    },
    {
      headerName: 'Brand',
      filter: true,
      minWidth: 100,
      flex: 1,
      field: 'brand',
      sortable: true,
      comparator: () => 0,
      cellRenderer: ({ data }) => {
        const { product } = data || {};
        const { brand = 'N/A' } = product || {};
        return (
          `${brand || 'N/A'}`
        );
      }
    },
    {
      headerName: 'Available Stock',
      filter: true,
      minWidth: 110,
      flex: 1,
      field:'available_stock',
      sortable:true,
      comparator: () => 0,
      cellRenderer: ({ data }) => {
        const { product } = data || {};
        const { warehouse_stock = 0, inbound_stock = 0, pending_on_po = 0, available_stock = 0 } = product || {};
        const total = Number(available_stock);

        return (
          <div className='card-wrapper gap-1'>
            <span>{total?.toLocaleString('en-US')}</span>
            <Popover
              title={null}
              content={<InfoTooltipData inbound={inbound_stock} warehouse={warehouse_stock || 0} pending={pending_on_po || 0} />}
              placement='right'>
              <img src={InfoIcon} className='info-icon-de' alt="InfoIcon" title="Info-Icon" />
            </Popover>
          </div>
        );
      }
    },
    {
      headerName: 'Unit Cost',
      sortable: true,
      filter: true,
      minWidth: 150,
      flex: 1,
      field: 'unit_cost',
      comparator: () => 0,
      cellRenderer: ({ value = 0, data }) => {
        const { id } = data || {};
        const showInput = (editPoItemData?.id === id) && (editPoItemData?.key === 'unit_cost');

        return (
          <div className='edit-able-data'>
            {
              showInput ? <Input
                autoFocus={true}
                defaultValue={newValue}
                onKeyDown={handleKeyDown}
                onBlur={(e) => handleSave(id, 'unit_cost', e.target.value)}
              /> :
                <span>${Number(value)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            }
            {status?.toLowerCase() !== 'processed' &&
              <BiSolidEdit className={showInput ? 'increase-font' : ''}
                onClick={() => {
                  setEditPoItemData({ id, key: 'unit_cost', value });
                  setNewValue(value);
                }}
              />
               }
          </div>
        );
      }
    },
    {
      headerName: 'Ask Price',
      sortable: false,
      filter: true,
      minWidth: 120,
      flex: 1,
      field: 'ask_price',
      comparator: () => 0,
      cellRenderer: ({ value }) =>
        (value === null || value === undefined || value === '')
          ? '-'
          : `$${Number(value)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
    {
      headerName: 'Extended Cost',
      sortable: true,
      filter: true,
      minWidth: 100,
      flex: 1,
      field: 'extended_cost',
      comparator: () => 0,
      // cellRenderer: ({ value = 0 }) => `$${Number(value).toFixed(2)}`
      cellRenderer: ({ value = 0 }) => `$${Number(value)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
    {
      headerName: 'Case QTY',
      sortable: true,
      filter: true,
      minWidth: 150,
      flex: 1,
      field: 'case_quantity',
      comparator: () => 0,
      cellRenderer: ({ value, data }) => {
        const { id } = data || {};
        const showInput = (editPoItemData?.id === id) && (editPoItemData?.key === 'case_quantity');

        return (
          <div className='edit-able-data'>
            {
              showInput ? <Input
                autoFocus={true}
                defaultValue={newValue}
                onKeyDown={handleKeyDown}
                onBlur={(e) => handleSave(id, 'case_quantity', e.target.value)}
              /> :
                <span>{Number(value || 0)?.toLocaleString('en-US')}</span>
            }
            {status?.toLowerCase() !== 'confirmed' && status?.toLowerCase() !== 'processed' && status?.toLowerCase() !== 'receiving' && status?.toLowerCase() !== 'arrived' &&
              <BiSolidEdit className={showInput ? 'increase-font' : ''}
                onClick={() => {
                  setEditPoItemData({ id, key: 'case_quantity', value });
                  setNewValue(value);
                }}
              />}
          </div>
        );
      }
    },
    {
      headerName: 'Ordered QTY',
      sortable: true,
      filter: true,
      minWidth: 150,
      flex: 1,
      field: 'order_quantity',
      comparator: () => 0,
      cellRenderer: ({ value, data }) => {
        const { id } = data || {};
        const showInput = (editPoItemData?.id === id) && (editPoItemData?.key === 'order_quantity');

        return (
          <div className='edit-able-data'>
            {
              showInput ? <Input
                autoFocus={true}
                defaultValue={newValue}
                onKeyDown={handleKeyDown}
                onBlur={(e) => handleSave(id, 'order_quantity', e.target.value)}
              /> :
                <span>{Number(value || 0)?.toLocaleString('en-US')}</span>
            }
            {status?.toLowerCase() !== 'processed' &&
              <BiSolidEdit className={showInput ? 'increase-font' : ''}
                onClick={() => {
                  setEditPoItemData({ id, key: 'order_quantity', value });
                  setNewValue(value);
                }}
              />
               }
          </div>
        );
      }
    },
    {
      headerName: 'Invoice QTY',
      sortable: true,
      filter: true,
      minWidth: 150,
      flex: 1,
      field: 'invoice_quantity',
      comparator: () => 0,
      cellRenderer: ({ value, data }) => {
        const { id } = data || {};
        const showInput = (editPoItemData?.id === id) && (editPoItemData?.key === 'invoice_quantity');

        return (
          <div className='edit-able-data'>
            {
              showInput ? <Input
                autoFocus={true}
                defaultValue={newValue}
                onKeyDown={handleKeyDown}
                onBlur={(e) => handleSave(id, 'invoice_quantity', e.target.value)}
              /> :
                <span>{Number(value || 0)?.toLocaleString('en-US')}</span>
            }
            {status?.toLowerCase() !== 'processed' &&
              <BiSolidEdit
                disabled={status?.toLowerCase() === 'processed' || status?.toLowerCase() === 'confirmed'}
                className={showInput ? 'increase-font' : ''}
                onClick={() => {
                  setEditPoItemData({ id, key: 'invoice_quantity', value });
                  setNewValue(value);
                }}
              />
            }
          </div>
        );
      }
    },
    {
      headerName: 'Received QTY',
      sortable: true,
      filter: true,
      minWidth: 100,
      flex: 1,
      field: 'received_quantity',
      comparator: () => 0,
      cellRenderer: ({ value }) => value?.toLocaleString('en-US') || 0
    },
    {
      headerName: 'Missing Units',
      minWidth: 140,
      flex: 1,
      field:'missing_units',
      sortable:true,
      comparator: () => 0,
      cellRenderer: ({ data }) => {
        const missingUnits = data?.missing_units || 0;
        if(status?.toLowerCase() === 'receiving' || status?.toLowerCase() === 'processed'){
          return <>{missingUnits > 0 ? missingUnits?.toLocaleString('en-US') : 0}</>;
        }

        return <>0  </>;
      }
    },
    {
      headerName: 'Notes',
      filter: true,
      minWidth: 280,
      flex: 1,
      field: 'notes',
      cellRenderer: ({ value, data }) => {
        const { id } = data || {};
        const showInput = (editPoItemData?.id === id) && (editPoItemData?.key === 'notes');

        return (
          <div className='edit-able-data not-edit'>
            {
              showInput ? <Input
                autoFocus={true}
                defaultValue={newValue}
                onKeyDown={handleKeyDown}
                onBlur={(e) => handleSave(id, 'notes', e.target.value)}
              /> :
                <Tooltip title={value || ''}>
                  <span>{value || '---'}</span>
                </Tooltip>
            }
            {status?.toLowerCase() !== 'confirmed' && status?.toLowerCase() !== 'processed' && status?.toLowerCase() !== 'receiving' && status?.toLowerCase() !== 'arrived' &&
              <BiSolidEdit className={showInput ? 'increase-font' : ''}
                onClick={() => {
                  setEditPoItemData({ id, key: 'notes', value });
                  setNewValue(value);
                }}
              />}
          </div>
        );
      }
    },
    {
      headerName: 'Action',
      filter: true,
      minWidth: 76,
      width: 76,
      pinned: 'right',
      headerClass: 'ag-center-aligned-header',
      headerStyle: { textAlign: 'center' },
      cellRenderer: ({ data }) => {
        const { received_quantity: productReceivedQty } = data || {};
        return (
          <div className="d-flex align-items-center justify-content-center gap-2" style={{ height: '100%' }}>
            {
              currentUser.role.id === 5 && (
                <Tooltip title='Receiving Page'>
                  <img
                    className='cursor-pointer'
                    src={SideDrawerIcon}
                    onClick={!(['pending', 'confirmed'].includes(poDetails?.status?.toLowerCase())) ? () => {
                      dispatch(GetWarehousePoHistory({ po_item_id: data?.id }));
                      openDrawer(data);
                    } : null}
                    alt='SideDrawerIcon'
                    style={{
                      cursor: ['pending', 'confirmed'].includes(poDetails?.status?.toLowerCase()) ? 'not-allowed' : 'pointer',
                      opacity: ['pending', 'confirmed'].includes(poDetails?.status?.toLowerCase()) ? 0.5 : 1,
                      marginRight: '10px'
                    }}
                  />
                </Tooltip>
              )
            }
            <AiOutlineDelete
              style={(status?.toLowerCase() === 'processed' || Number(productReceivedQty) > 0) ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
              onClick={() => {
                if (!['processed'].includes(status?.toLowerCase()) && Number(productReceivedQty) === 0) {
                  handleOpen(data?.id);
                }
              }}
              className='delete-icon'
            />
          </div>
        );
      }
    }
  ];

  const defaultColDefNew = {
    resizable: true,
    sortable: false,
    filter: false,
    suppressRowClickSelection: true,
    suppressMenu: true,
    suppressMovable: true,
    enableCellTextSelection: false,
    suppressCellFocus: true

  };

  const InfoTooltipData = ({ inbound, warehouse, pending }) => {
    return (
      <PoDetailsWrapper className='mt-0'>
        <div className='container-box'>
          <div className='items'>
            <span>Inbound Stock</span>
            <span>{inbound || 0}</span>
          </div>
          <div className='items'>
            <span>Warehouse Stock</span>
            <span>{warehouse || 0}</span>
          </div>
          <div className='items'>
            <span>Pending on PO</span>
            <span>{pending || 0}</span>
          </div>
        </div>
      </PoDetailsWrapper>
    );
  };
  const SelectExportType = ()=>{
    return (
      <PoDetailsWrapper ref={divRef} className='mt-0'>
        <div className='items-menu'>
          <span onClick={() => handleExportPoItems()}>Export Selected</span>
          <span onClick={handleExportFiltered}>Export Filtered</span>
          <span onClick={handleExportAll}>Export All</span>
          <span onClick={handleExportAsinData}>Export ASIN Data</span>
        </div>
      </PoDetailsWrapper>
    );
  };

  const SelectAddProductType = () => {
    return (
      <PoDetailsWrapper ref={divRef} className='mt-0'>
        <div className='items-menu'>
          <span onClick={handleAddProductByUpload}> Add Manually</span>
          <span onClick={() => {
            setAddProductFile(true);
            handleClosePopover(true);
          }}>Add by Upload File</span>
          <span onClick={() => {
            setPoItemsSkuMapping(true);
            handleClosePopover(true);
          }}>Add &amp; Map by Upload File</span>
        </div>
      </PoDetailsWrapper>
    );
  };

  const handleTogglePopover = (e) => {
    setOpenAddProduct(!openAddProduct);
    e.stopPropagation();
  };

  const handleExportToggle = (e)=>{
    setOpenExport(!openExport);
    e.stopPropagation();
  };

  const handleWindowClick = () => {
    setOpenAddProduct(false);
  };

  useEffect(() => {
    window.addEventListener('click', handleWindowClick);

    return () => {
      window.removeEventListener('click', handleWindowClick);
    };
  }, []);

  const handleClosePopover = (value) => {
    setOpenAddProduct(false);
    setUploadAddProduct(value);
    if (uploadAddProduct === true) {
      setAddProduct(true);
    } else {
      setAddProduct(true);
    }
  };

  const handleAddProductByUpload = () => {
    setShowDrawer(true);
    setOpenAddProduct(false);
  };

  const handleOpen = (po_item_id) => {
    setIsModalOpen(true);
    setPoItemId(po_item_id);
  };

  const openDrawer = (data) => {
    setSelectedData(data);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedData(null);
  };

  const handlePoUpdate = (status) => {
    dispatch(UpdatePo({ poId: poId, status: status })).then(() => {
      refreshGridClick();
    });
    setIsConfirm(false);
    setRevertReceivingStatus(false);
    setMarkAsReceivedModal(false);
    setArrivedModalOpen(false);
  };

  const handleBulkReceive = () => {
    dispatch(BulkReceive({ poId: poId })).then(({ payload }) => {
      if (payload?.success) {
        refreshGridClick();
        setBulkReceivingModal(false);
      }
    });
  };

  const handleDeleteModalOpen = () => {
    const selectedRows = gridApi.getSelectedRows();

    if (selectedRows.length === 0) {
      notification.error({
        top: 65,
        message: 'Delete PO Items',
        description: 'Please select at least one po item to delete.'
      });
      return;
    }
    setDeleteModalOpen(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false);
  };

  const addProductHandleClose = () => {
    setAddProduct(false);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setArrivedModalOpen(false);
  };

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(GetPoItems({
      id: poId,
      page: newPage,
      filters,
      sortBy
    }));
  };

  const refreshGridClick = () => {
    dispatch(GetPoItems({
      id: poId,
      page,
      filters,
      sortBy
    }));
    dispatch(GetPoDetails(poId));
  };

  const gridReady = (params) => {
    gridApi = params.api;
    gridColumnApi = params.columnApi;
  };

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null);

    if (value && ['unit_cost', 'extended_cost', 'case_quantity', 'order_quantity', 'invoice_quantity', 'received_quantity', 'missing_units', 'brand', 'title', 'identifier_value', 'available_stock'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(GetPoItems({
        id: poId,
        page,
        filters,
        sortBy: { key: colId, type: sort }
      }));
    }
  };

  const handleExportAll = ()=>{
    dispatch(GetPoItems({
      id : poId,
      exportAll:true
    })).then(({payload})=>{
      if(payload.success == true){
        handleExportPoItems(payload.result);
      }
    });
  };

  const handleExportFiltered = () => {
    const isFilterApplied = Object.entries(filters).some(([key, value]) => {
      if (key === 'itemsFilter') return value !== 'viewAll';
      return value !== '';
    });

    if (!isFilterApplied) {
      notification.error({
        top: 65,
        message: 'Export Filtered',
        description: 'Please Select a Filter First'
      });
      return;
    }

    dispatch(ExportFilteredPoItems({
      id: poId,
      filters,
      sortBy
    })).then(({ payload }) => {
      if (payload.success == true) {
        handleExportPoItems(payload.result);
      }
    });
  };

  const handleExportAsinData = () => {
    dispatch(ExportAsinData({ poId: poId })).then(({ payload }) => {
      if (payload?.success) {
        if(payload.fileUrl){
          window.open(payload.fileUrl, '_blank');
        }
        else {
          notification.error({
            top: 65,
            message: 'Export Asin Data',
            description: 'No ASIN data found.'
          });
        }
      }
    });
  };

  const handleExportPoItems = (data) => {
    setOpenExport(false);
    let sortedSelectedRows;

    if (isArray(data)) {
        sortedSelectedRows = data;
         
    } else {
        const selectedRows = selectedPoItems;
    
        if (selectedRows.length === 0) {
            notification.error({
                top: 65,
                message: 'Export Po Items',
                description: 'Please select at least one row to export.'
            });
            return;
        }
    
        sortedSelectedRows = sort(selectedRows, (item) => indexOf(poItems, item));
    }

    const mappedData = sortedSelectedRows?.map((poItem) => {
      const {
        identifier_type,
        identifier_value,
        unit_cost,
        ask_price,
        extended_cost,
        case_quantity,
        order_quantity,
        invoice_quantity,
        received_quantity,
        notes,
        product
      } = poItem || {};

      return {
        Title: product?.name || 'N/A',
        ImageUrl: product?.image_url || 'N/A',
        identifier_type: identifier_type?.toUpperCase() || product?.identifier_type?.toUpperCase(),
        identifier_value: identifier_value || 'N/A',
        Brand: product?.brand || 'N/A',
        unit_cost : unit_cost || 0,
        ask_price : ask_price || 0,
        extended_cost: extended_cost || 0,
        case_quantity : case_quantity || 0,
        order_quantity : order_quantity || 0,
        invoice_quantity : invoice_quantity || 0,
        received_quantity : received_quantity || 0,
        notes : notes || 'N/A'
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'PO Items');

    XLSX.writeFile(workbook, 'PO Items.xlsx');
  };

  const handleDeleteBulkPoItems = () => {
    const selectedRows = gridApi.getSelectedRows();

    if (selectedRows.length === 0) {
      notification.error({
        top: 65,
        message: 'Delete PO Items',
        description: 'Please select at least one po item to delete.'
      });
      return;
    }

    const poItemIds = selectedRows?.map((poItem) => {
      const {
        id
      } = poItem || {};
      return id;
    });

    dispatch(DeleteBulkPoItem({ po_item_ids: poItemIds })).then(({ payload }) => {
      if (payload?.success) {
        handleDeleteModalClose();
        refreshPage();
      }
    });
  };

  const refreshPage = (poItemId) => {

    if (gridColumnApi){
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true
      });
      setSortBy({ key: '', type: '' });
    }

    setFilters(filters => {
      dispatch(GetPoItems({
        id: poId,
        page,
        filters
      })).then(() => expandRow(poItemId));
      return filters;
    });
    setPage(page);
    setIsRowSelected(false);
    dispatch(GetPoDetails(poId));
  };

  const expandRow = (rowId) => {
    if (gridApi && rowId) {
      gridApi.forEachNode((node) => {
        if (node.data.id === rowId) {
          node.setExpanded(true);
        }
      });
    }
  };

  const handleOpenPoEditModal = () => {
    setAddProduct(true);
    setEditPoItems(true);
  };

  const handleVisibleChange = (visible) => {
    setPopoverVisible(visible);
    setUploadFile({});
  };

  const uploadProps = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    accept: ['.xlsx', '.xls'],
    fileList: !isEmpty(uploadFile) ? [{ ...uploadFile, name: uploadFile.name, key: uploadFile.uid || uploadFile.name }] : [],
    onChange(info) {
      if (info.fileList.length === 0) {
        return;
      }
      const file = info.file;
      const fileExtension = file.name.split('.')[1];

      if (!['xls', 'xlsx'].includes(fileExtension)) {
        message.error(`${file.name} upload failed. Only Excel files are allowed.`);
        return;
      }
      setUploadFile(file);
    },
    beforeUpload: () => false,
    onRemove: () => {
      setUploadFile({});
      return true;
    }
  };
  
  const condiltionalColumnDefs = status?.toLowerCase() === 'confirmed' || status?.toLowerCase() === 'pending' ? columnDefs.filter((column)=>column.headerName !== 'Received QTY' && column.headerName !== 'Missing Units') : columnDefs;
 
  const content = (
    <Spin tip='Loading...' spinning={fileUploadingLoading}>
      <InventoryWrapper style={{ width: 350 }} className='pt-0'>
        <Dragger {...uploadProps} style={{ marginTop: 16, padding: 16, borderRadius: 8 }}>
          <p className="ant-upload-drag-icon">
            <img src={uploadIcon} alt='upload' />
          </p>
          <p className="ant-upload-text text-primary fs-14 fw-semibold text-decoration-underline">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">
            Support for a single upload
          </p>
        </Dragger>
        <p className="text-grey d-flex align-items-center gap-1 mt-2">
          <img src={WarningInfoIcon} alt="warning" />
          <span className="fs-12 fw-semibold">Products With Invalid Invoice Quantity will not be added</span>
        </p>

        <h6>Uploaded Files</h6>
        {
          !isEmpty(uploadFile) &&
          <div className="uploaded-file-container">
            <div key={uploadFile.uid} className="uploading-content-data">
              <div className="title">
                <img src={FileIcon} alt="File Icon" title="File Icon" />
                <span>{uploadFile.name}</span>
              </div>
              <AiOutlineDelete onClick={() => setUploadFile({})} style={{ cursor: 'pointer', color: 'red' }} />
            </div>
          </div>
        }

        <div className='d-flex gap-2 justify-content-end mt-3'>
          <Button
            text="Cancel"
            className="outlined mb-0"
            onClick={() => {
              setPopoverVisible(false);
              setUploadFile({});
            }
            } />
          <Button
            text={fileUploadingLoading ? 'Uploading..' : 'Save'}
            disabled={fileUploadingLoading || isEmpty(uploadFile)}
            className="primary mb-0"
            onClick={handleFileUpload}
          />
        </div>
      </InventoryWrapper>
    </Spin>
  );

  const getUniqueSkusWithMinShipQuantity = (sourceItems = orderItems) => {
    // Defensive: filter out undefined skus that can appear when a selected product had no seller_skus
    // at selection time (pre-SKU-mapping). Without this, minBy returns undefined and the next .map crashes.
    const allSkus = flatMap(sourceItems, 'skus').filter(Boolean);
    const groupedSkus = groupBy(allSkus, 'sku_id');
    const mappedResult = map(groupedSkus, (skus) => minBy(skus, 'ship_quantity')).filter(Boolean);

    const updatedMappedResult = mappedResult.map(mappedItem => {
      const matchingSku = poItems
        .flatMap(po => po.seller_skus || [])
        .find(sku => sku && sku.id === mappedItem.sku_id);

      const totalWarehouseStock = Number(matchingSku?.warehouse_stock + matchingSku?.po_sku_mappings_v2?.ship_quantity);
      const addedShipQty = Number(matchingSku?.po_sku_mappings_v2?.ship_quantity);
      if (((matchingSku && totalWarehouseStock < addedShipQty) || mappedItem?.po_sku_mappings_v2?.ship_quantity === 0)) {
        return {
          ...mappedItem,
          ship_quantity: 0,
          is_errored: true
        };
      }

      return mappedItem;
    });

    return updatedMappedResult;
  };

  // Build fresh orderItems shape directly from current grid selection — avoids stale
  // state when products were selected before SKU mapping was uploaded.
  const buildOrderItemsFromRows = (rows = []) => rows.map(({ product, seller_skus }) => ({
    product_id: product?.id,
    skus: (seller_skus || []).map(({ id: sku_id, po_sku_mappings_v2 = {}, warehouse_stock = 0 }) => ({
      sku_id,
      ship_quantity: po_sku_mappings_v2.ship_quantity,
      warehouse_stock,
    })),
  }));

  const handleCreateWorkOrder = () => {
    setShowWorkOrderOption(false);
    const selectedRows = selectedPoItems || [];
    if (selectedRows.length === 0) {
      notification.error({
        top: 65,
        message: 'Create Work Order',
        description: 'Please select at least one row to create.'
      });
      return;
    }
    const rowsWithSkus = selectedRows.filter(row => (row?.seller_skus || []).length > 0);
    if (rowsWithSkus.length === 0) {
      notification.error({
        top: 65,
        message: 'Create Work Order',
        description: 'Selected rows have no mapped SKUs.'
      });
      return;
    }

    // Collect unique SKUs from selection; only filter is warehouse_stock > 0
    // (matches backend behavior). Avoids the prior minBy/groupBy pipeline that
    // dropped SKUs whose ship_quantity was undefined.
    const skuMap = new Map();
    for (const row of rowsWithSkus) {
      for (const sku of row.seller_skus || []) {
        const sku_id = sku?.id || sku?.sku_id;
        if (!sku_id || skuMap.has(sku_id)) continue;
        if (Number(sku?.warehouse_stock || 0) <= 0) continue;
        skuMap.set(sku_id, {
          sku_id,
          ship_quantity: sku?.po_sku_mappings_v2?.ship_quantity || 0,
        });
      }
    }
    const uniqueOrderSkus = Array.from(skuMap.values());

    if (uniqueOrderSkus.length === 0) {
      notification.error({
        top: 65,
        message: 'Create Work Order',
        description: 'Selected SKUs have no warehouse stock.'
      });
      return;
    }

    const productIds = orderItems?.filter(({ isHighlighted }) => isHighlighted)?.map(({ product_id }) => product_id) || [];
    dispatch(populateHighlightState({
      productIds
    }));

    dispatch(CreateWorkOrder({
      orderItems: uniqueOrderSkus
    }))
      .then(({ payload }) => {
        const { success, workOrderId } = payload || {};
        if (success) navigate(`/inventory/work-order/${workOrderId}`);
      });
  };

  const onSelectionChange = (e) => {
    if (!e) {
      // Manual refresh of selection into grid
      if (gridApi && poItems?.length > 0) {
        gridApi.forEachNode((node) => {
          if (selectedPoItems.some(i => i.id === node.data.id)) {
            node.setSelected(true, false, true);
          }
        });
      }
    }
    else {
      const currentPageSelected = gridApi?.getSelectedRows?.() || [];
      const currentPageAll = poItems || [];
      const currentPageAllIds = currentPageAll.map(i => i.id);

      setSelectedPoItems(prev => {
        const otherPagesSelected = prev.filter(i => !currentPageAllIds.includes(i.id));
        const newSelected = [...otherPagesSelected, ...currentPageSelected];
        setIsRowSelected(newSelected.length > 0);
        
        // Update orderItems based on full selection
        const data = newSelected?.map(({ product, seller_skus, received_quantity = 0, warehouse_stock }) => {
          const skus = seller_skus?.map(({ id: sku_id, po_sku_mappings_v2 = {}, warehouse_stock = 0 }) => ({ sku_id, ship_quantity: po_sku_mappings_v2.ship_quantity, warehouse_stock }));
          const totalShipQuantity = skus.reduce(
            (sum, sku) => {
              const skuData = find(seller_skus, ({ id }) => id === sku.sku_id);
              return sum + ((sku.ship_quantity || 0) * (skuData?.po_sku_mappings_v2?.bundle_quantity || 1));
            },
            0
          );

          const remainingWarehouseStock = skus.reduce(
            (sum, sku) => {
              const skuData = find(seller_skus, ({ id }) => id === sku.sku_id);
              return sum + ((sku.warehouse_stock || 0) * (skuData?.po_sku_mappings_v2?.bundle_quantity || 1));
            },
            0
          );

          const totalWarehouseStock = totalShipQuantity + remainingWarehouseStock;

          return {
            product_id: product?.id,
            skus,
            isHighlighted:  totalShipQuantity > totalWarehouseStock ? true : false
          };
        });
        setOrderItems(data);
        
        return newSelected;
      });
    }
  };

  const handleCreateWorkOrderWithPO = () => {
    if (['confirmed', 'arrived'].includes(status?.toLowerCase())){
      dispatch(CreateWorkOrder({
        po_id: poId
      }))
        .then(({ payload }) => {
          const { success, workOrderId } = payload || {};
          if (success) navigate(`/inventory/work-order/${workOrderId}`);
        });
    }
    else{
      dispatch(GetErroredItems({
        po_id: poId,
        page: { pageSize: 25, pageNumber: 1 }
      }))
        .then(({ payload }) => {
          if (payload?.count) {
            setShowErroredItemsModal(true);
          }
          else {
            dispatch(CreateWorkOrder({
              po_id: poId
            }))
              .then(({ payload }) => {
                const { success, workOrderId } = payload || {};
                if (success) navigate(`/inventory/work-order/${workOrderId}`);
              });
          }
        });
    }
    setShowWorkOrderOption(false);
  };

  const handleMarkAsArrived = () => {
    if (poDetails?.status?.toLowerCase() === 'confirmed') {
      setArrivedModalOpen(true);
    }
  };

  const handleAddSelectedToExistingDraftWo = () => {
    setShowWorkOrderOption(false);
    const selectedRows = selectedPoItems || [];
    if (selectedRows.length === 0) {
      notification.error({ top: 65, message: 'Add to Existing Draft Work Order', description: 'Please select at least one row.' });
      return;
    }
    const rowsWithSkus = selectedRows.filter(row => (row?.seller_skus || []).length > 0);
    if (rowsWithSkus.length === 0) {
      notification.error({ top: 65, message: 'Add to Existing Draft Work Order', description: 'Selected rows have no mapped SKUs.' });
      return;
    }
    setPreparingAddToDraftWo(true);
    dispatch(GetUserWorkOrders({ page: { pageSize: 50, pageNumber: 1 }, filters: { status: 'Draft', search: '' } }))
      .finally(() => {
        setPreparingAddToDraftWo(false);
        setAddToDraftWoItems(rowsWithSkus);
        setShowAddToDraftWoModal(true);
      });
  };

  const handleAddAllToExistingDraftWo = () => {
    setShowWorkOrderOption(false);
    setPreparingAddToDraftWo(true);
    Promise.all([
      dispatch(GetUserWorkOrders({ page: { pageSize: 50, pageNumber: 1 }, filters: { status: 'Draft', search: '' } })),
      dispatch(GetPoItemsForDraftWoModal({ id: poId, exportAll: true })),
    ]).then(([, poItemsAction]) => {
      if (!GetPoItemsForDraftWoModal.fulfilled.match(poItemsAction)) {
        // Fetch failed — the thunk already surfaced an error notification.
        return;
      }
      // Block opening the modal when no PO item maps to a SKU — there'd be nothing to add.
      const poItems = poItemsAction.payload?.result || [];
      const hasMappedSkus = poItems.some(item => (item?.seller_skus || []).length > 0);
      if (!hasMappedSkus) {
        notification.error({ top: 65, message: 'Add to Existing Draft Work Order', description: 'PO items have no mapped SKUs.' });
        return;
      }
      setAddToDraftWoItems([]);
      setShowAddToDraftWoModal(true);
    }).finally(() => {
      setPreparingAddToDraftWo(false);
    });
  };

  const CreateWorkOrderDropdown = () => {
    return (
      <PoDetailsWrapper ref={divRef} className='mt-0'>
        <div className='items-menu'>
          {/* <span onClick={handleCreateWorkOrder}>Create with Selected Items</span>
          <span onClick={handleCreateWorkOrderWithPO}>Create with All PO Items</span> */}
          <span onClick={handleAddSelectedToExistingDraftWo}>Create with Selected Items</span>
          <span onClick={handleAddAllToExistingDraftWo}>Create with All PO Items</span>
        </div>
      </PoDetailsWrapper>
    );
  };

  const { pageNumber, pageSize } = page || {};

  return (
    <PoDetailsWrapper>
      <div className='po-detail-header'>
        <div className='header-info'>
          <span className='back-button' onClick={() => navigate('/po-history')}><FiArrowLeft size={18} /></span>
          <h5 className='header-po-name'>{file_name}</h5>
          <span className={`po-status-badge ${getPoStatusBadgeClass(status)}`}>{capitalize(status) || ''}</span>
          <span className='header-divider'>|</span>
          <span className='header-vendor'>{vendor?.name || 'N/A'}</span>
        </div>
        <div className='buttons-wrapper'>
          <Button onClick={() => {
            setUploadMapping(true);
            handleClosePopover(true);
          }}
            className="outlined" startIcon={<GoUpload />} text="Upload SKU Mapping" />
          {
            ['receiving', 'processed', 'confirmed', 'arrived', 'pending'].includes(status?.toLowerCase()) &&
            <Popover
              visible={showWorkOrderOption}
              overlayStyle={{ padding: 0 }}
              overlayClassName='dropdown-pop'
              trigger='click'
              Arrow={false}
              placement='bottom'
              title={null}
              content={<CreateWorkOrderDropdown />}
            >
              <Spin size='small' spinning={creatingWorkOrder}>
                <Button
                  disabled={!poItems?.length || creatingWorkOrder || (currentUser?.is_employee_of && !currentUser?.permissions.includes(3))}
                  onClick={() => setShowWorkOrderOption(showWorkOrderOption => !showWorkOrderOption)}
                  startIcon={<FiPlus style={{ marginRight: '16px' }} />}
                  endIcon={<IoIosArrowDown />}
                  className="outlined"
                  text="Create Work Order"
                />
              </Spin>
            </Popover>
          }
          {(() => {
            const roleId = currentUser?.role?.id;

            const lowerStatus = status?.toLowerCase();
            const disabledConfirm =
              ['confirmed', 'processed', 'receiving', 'arrived'].includes(lowerStatus) ||
              !poItems?.length;

            if (roleId !== 5) {
              return (
                <Button
                  text="Confirm PO"
                  disabled={disabledConfirm}
                  onClick={() => setIsConfirm(true)}
                />
              );
            }

            if (lowerStatus === 'pending') {
              return (
                <Button
                  text="Confirm PO"
                  disabled={disabledConfirm}
                  onClick={() => setIsConfirm(true)}
                />
              );
            }

            switch (lowerStatus) {
              case 'confirmed':
                return (
                  <Button
                    text="Mark as Arrived"
                    disabled={['arrived', 'receiving', 'processed'].includes(lowerStatus)}
                    onClick={handleMarkAsArrived}
                  />
                );

              case 'receiving':
              case 'arrived':
                const disableReceive =
                  ['processed', 'confirmed', 'pending'].includes(poDetails?.status?.toLowerCase()) ||
                  poItems?.length === 0;
                return (
                  <>
                    <Button
                      disabled={disableReceive}
                      text="Bulk Receive"
                      onClick={() => setBulkReceivingModal(true)}
                    />
                    <Button
                      disabled={disableReceive}
                      text="Mark As Received"
                      onClick={() => setMarkAsReceivedModal(true)}
                    />
                  </>
                );

              case 'processed':
                return (
                  <Button
                    text="Move Back to Receiving"
                    className={
                      poDetails.status?.toLowerCase() === 'confirmed'
                        ? 'disabled-save-button'
                        : 'map-btn-wrapper'
                    }
                    onClick={() => setRevertReceivingStatus(true)}
                  />
                );

              default:
                return (
                  <Button
                    text="Confirm PO"
                    disabled={disabledConfirm}
                    onClick={() => setIsConfirm(true)}
                  />
                );
            }
          })()}
        </div>
      </div>
      <div className='box-row'>
        {boxData.map((data, ind) => (
          <div key={ind} className={`sku-box ${filters.tilesFilter === data.key ? 'active-box' : ''} ${data.className}`}>
            <p>{data.label}</p>
            <h4>{data.value}</h4>
          </div>
        ))}
      </div>
      <div className='po-items-toolbar'>
        <SearchInput
          className="toolbar-search"
          placeholder="Search by UPC, EAN, ISBN, Title, Brand"
          width="280px"
          onChange={({ target }) => handleSearchProduct(target.value)}
        />
        <div className='toolbar-actions'>
          <Popover
            content={content}
            trigger="click"
            placement="bottomRight"
            visible={popoverVisible}
            onVisibleChange={handleVisibleChange}
          />
          <Button disabled={status?.toLowerCase() === 'processed' || !isRowSelected || gridApi.getSelectedRows().some(row => row.received_quantity > 0)} className="danger mb-0" text="Delete Items" onClick={handleDeleteModalOpen} />
          <Button endIcon={<BiSolidEdit />} disabled={status?.toLowerCase() === 'processed'} className="outlined mb-0" text="Bulk Edit" onClick={handleOpenPoEditModal} />
          <Popover visible={openAddProduct} overlayStyle={{ padding: 0 }} overlayClassName='dropdown-pop' trigger='click' Arrow={false} placement='bottom' title={null} content={<SelectAddProductType />}>
            <Button disabled={status?.toLowerCase() === 'processed'} onClick={handleTogglePopover} startIcon={<FiPlus />} endIcon={<IoIosArrowDown />} className="outlined mb-0" text="Add Items" />
          </Popover>
          {highlightRows && <Alert title="Ship Qty doesn't match with Received Qty" count={<span>{orderItems.filter(({ isHighlighted }) => isHighlighted)?.length || 0}</span>} />}
          <Popover visible={openExport} overlayStyle={{ padding: 0 }} overlayClassName='dropdown-pop' trigger='click' Arrow={false} placement='bottom' title={null} content={<SelectExportType />}>
            <Spin size='small' spinning={exportingData}>
              <Button disabled={!poItems?.length || exportingData} onClick={handleExportToggle} startIcon={<GoUpload style={{marginRight:'4px'}}/>} endIcon={<IoIosArrowDown />} className="outlined mb-0" text="Export" />
            </Spin>
          </Popover>
        </div>
      </div>
      <div ref={tableSectionRef}>
        <Spin tip='Loading...' spinning={fetchingPoItems || confirmingPo || updatingPoItem || deletingPoItem || creatingWorkOrder || fetchingErroredItems || fetchingWarehousePoDetails || preparingAddToDraftWo}>
          <AgGrid
            user_referrals={poItems}
            defaultColDef={defaultColDefNew}
            columnDefinitions={condiltionalColumnDefs}
            gridReady={gridReady}
            rowHeight={52}
            headerHeight={34}
            containerHeight={tableHeight}
            masterDetail={true}
            detailRowAutoHeight={true}
            onSortChange={onSortChange}
            onSelectionChanged={onSelectionChange}
            detailCellRenderer={(props) => <PoRowDetails
              {...props}
              refreshPage={refreshPage}
              setOrderItems={setOrderItems}
              orderItems={orderItems}
              onParentSelectionChange={onSelectionChange}
            />}
            className="sku-table"
            rowSelection='multiple'
          />
        </Spin>
      </div>
      <div ref={paginationRef}>
        <Pagination
          total={totalPoItemsCount}
          totalPages={ceil(totalPoItemsCount / pageSize + 1)}
          pageNumber={pageNumber}
          pageLimit={pageSize}
          handleLimitChange={(e) => handlePagination(e, 'pageSize')}
          handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
          handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
          handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
          refreshGridClick={refreshPage}
          isExport={true}
        />
      </div>
      <Modal
        open={isModalOpen}
        onClose={handleClose}
        onHide={handleClose}
        closeText="Cancel"
        saveText="Confirm"
        header="Delete Confirmation"
        className="delete-confirmation-modal"
        closeButton={true}
        buttonDisabled={deletingPoItem}
        onSave={() => {
          console.log('Item deleted');
          dispatch(DeletePoItem(poItemId)).then(({ payload }) => {
            if (payload?.success) {
              handleClose();
              refreshPage();
            }
          });
        }}
      >
        <PoDetailsWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
            <h3>Warning</h3>
            <p>Are you sure you want to delete this Item?</p>
          </div>
        </PoDetailsWrapper>
      </Modal>
      <Modal
        open={deleteModalOpen}
        onClose={handleDeleteModalClose}
        onHide={handleDeleteModalClose}
        closeText="Cancel"
        saveText="Confirm"
        header="Delete Confirmation"
        className="delete-confirmation-modal"
        closeButton={true}
        buttonDisabled={deletingPoItem}
        onSave={handleDeleteBulkPoItems}
      >
        <PoDetailsWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
            <h3>Warning</h3>
            <p>Are you sure you want to delete these Items?</p>
          </div>
        </PoDetailsWrapper>
      </Modal>
      <Modal
        open={isConfirm}
        onClose={() => setIsConfirm(false)}
        onHide={() => setIsConfirm(false)}
        closeText="Cancel"
        saveText="Confirm"
        header="Delete Confirmation"
        className="delete-confirmation-modal"
        buttonDisabled={confirmingPo}
        closeButton={true}
        onSave={() => {
          dispatch(ConfirmPo(poId)).then(({ payload }) => {
            if (payload?.success) setIsConfirm(false);
            refreshGridClick();
          });

        }}
      >
        <PoDetailsWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
            <h3>Confirm PO</h3>
            <p>Are you sure you want to confirm this PO?</p>
          </div>
        </PoDetailsWrapper>
      </Modal>

      <ErroredItemsModal
        showErroredItemsModal={showErroredItemsModal}
        setShowErroredItemsModal={setShowErroredItemsModal}
      />

      <AddToDraftWoModal
        open={showAddToDraftWoModal}
        onHide={() => {
          setShowAddToDraftWoModal(false);
          setAddToDraftWoItems([]);
        }}
        poId={poId || poDetails?.id}
        items={addToDraftWoItems}
        onSuccess={(workOrderId) => navigate(`/inventory/work-order/${workOrderId}`)}
      />

      <AddManualProduct
        refreshGridClick={() => refreshPage()}
        uploadAddProduct={uploadAddProduct}
        editPoItems={editPoItems}
        setEditPoItems={setEditPoItems}
        addProduct={addProduct}
        setAddProduct={setAddProduct}
        uploadMapping={uploadMapping}
        setUploadMapping={setUploadMapping}
        addProductFile={addProductFile}
        setAddProductFile={setAddProductFile}
        poItemsSkuMapping={poItemsSkuMapping}
        setPoItemsSkuMapping={setPoItemsSkuMapping}
      />
      {
        showDrawer &&
        <AddProductByUpload
          setShowDrawer={setShowDrawer}
          setAddProduct={setAddProduct}
          showDrawer={showDrawer}
          refreshPage={refreshPage}
        />
      }
      <ReceiveProductDrawer
        title='Receive Product'
        placement='right'
        onClose={closeDrawer}
        visible={isDrawerOpen}
        rowData={selectedData}
        po_status={poDetails.status}
        filters={filters}
        page={page}
        poId={poId}
      />
        <Modal
          open={revertReceivingStatus}
          onClose={() => setRevertReceivingStatus(false)}
          onHide={() => setRevertReceivingStatus(false)}
          closeText="Cancel"
          saveText="Move Back"
          className="delete-confirmation-modal"
          closeButton={true}
          onSave={() => {
            handlePoUpdate('Receiving');
          }}
        >
          <PoWarehouseDetailsWrapper>
            <div className='delete-modal-wrapper'>
              <img src={Receiving} alt='Receiving' title='Receiving' />
              <h3>Move Back to Receiving</h3>
              <p>Are you sure you want to move this PO back to receiving status?</p>
            </div>
          </PoWarehouseDetailsWrapper>
        </Modal>
        <Modal
          open={bulkReceivingModal}
          onClose={() => setBulkReceivingModal(false)}
          onHide={() => setBulkReceivingModal(false)}
          closeText="Cancel"
          saveText="Yes"
          className="delete-confirmation-modal"
          closeButton={true}
          onSave={() => {
            handleBulkReceive();
          }}
          buttonDisabled={bulkReceivingLoading}
        >
          <PoWarehouseDetailsWrapper>
            <div className='delete-modal-wrapper'>
              <img src={Receiving} alt='Receiving' title='Receiving' />
              <h3>Bulk Receive</h3>
              <p>Are You Sure You Want To Bulk Receive All Po Items?</p>
            </div>
          </PoWarehouseDetailsWrapper>
        </Modal>
        <Modal
          open={markAsReceivedModal}
          onClose={() => setMarkAsReceivedModal(false)}
          onHide={() => setMarkAsReceivedModal(false)}
          closeText="Cancel"
          saveText="Confirm"
          header="Delete Confirmation"
          className="delete-confirmation-modal"
          closeButton={true}
          onSave={() => {
            handlePoUpdate('Processed');
          }}
        >
          <PoWarehouseDetailsWrapper>
            <div className='delete-modal-wrapper'>
              <img src={MarkAsResolved} alt='MarkAsResolved' title='MarkAsResolved' />
              <h3>Mark as Received</h3>
              <p>Are you sure you want to mark this as received?</p>
            </div>
          </PoWarehouseDetailsWrapper>
        </Modal>
        <Modal
          open={arrivedModalOpen}
          onClose={handleClose}
          onHide={handleClose}
          closeText='Cancel'
          saveText='Confirm'
          header='Arrived Confirmation'
          className='delete-confirmation-modal'
          closeButton={true}
          onSave={() => handlePoUpdate('Arrived')}
        >
          <ModalWrapper>
            <div className='delete-modal-wrapper'>
              <img src={MarkAsResolved} alt='WarningIcon' title='WarningIcon' />
              <h3>Mark As Arrived</h3>
              <p>Do You Mark This PO As Arrived ?</p>
            </div>
          </ModalWrapper>
        </Modal>


    </PoDetailsWrapper >
  );
};

export default PoDetails;
